<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Planilha Fechamento" />

      <Lynx-Button
        v-if="!competencia.gerado"
        text="Carregar planilha"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="carregarPlanilha()"
      />

      <Lynx-Button
        v-else
        text="Atualizar planilha"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="listar_planilha()"
      />
      <Lynx-Button
        v-if="competencia.gerado"
        text="Carregar guias e notas"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="carregarPlanilha()"
      />

      <!-- <Lynx-Button
        text="Export Fechamento"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="exportPlanilha('exportPlanilha')"
      />
      <Lynx-Button
        text="Export Distribuição de Lucros"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="exportPlanilha('ExportDistribuicao')" -->
    </div>
    <div class="flex justify-end">
      <v-menu offset-x>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            style="border-radius: 25px"
            color="#031127"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Relatorios
          </v-btn>
        </template>
        <div class="flex flex-col">
          <v-btn
            color="#031127"
            dark
            @click.native="exportPlanilha('exportPlanilha')"
          >
            Export Fechamento
          </v-btn>
          <v-btn
            class="mt-1"
            color="#031127"
            dark
            @click.native="exportPlanilha('ExportDistribuicao')"
          >
            Export Distribuição de Lucros
          </v-btn>
        </div>

        <!-- <v-list>
          <v-list-item>
            <v-btn
              style="border-radius: 25px"
              color="#031127"
              dark
        
              @click.native="exportPlanilha('exportPlanilha')"
            >
            Export Fechamento
            </v-btn>
          </v-list-item>
          <v-list-item
            ><v-btn
              style="border-radius: 25px"
              color="#031127"
              dark
              @click.native="exportPlanilha('ExportDistribuicao')"
      
            >
            Export Distribuição de Lucros
            </v-btn></v-list-item
          >
        </v-list> -->
      </v-menu>
    </div>
    <div class="w-full flex justify-start gap-4 items-center mb-2">
      <label class="w-1/5">
        <Lynx-Label label="Prolabore valor" class=" " />

        <InputMoney
          required
          @input="(money) => (prolabore_filter = money)"
          v-model="filtros.prolabore_filter"
        ></InputMoney>
      </label>
      <label class="w-1/5">
        <Lynx-Label label="Faturamento valor" class=" " />

        <InputMoney
          required
          @input="(money) => (faturamento_filter = money)"
          v-model="filtros.faturamento_filter"
        ></InputMoney>
      </label>
      <label class="w-1/5">
        <Lynx-Label label="Data Inicio" class=" " />

        <Lynx-Input type="date" v-model="filtros.filtro_data" />
      </label>
    </div>

    <div class="w-full flex justify-start gap-4 items-center mb-2">
      <label class="w-1/5">
        <Lynx-Label label="Carteiras" class=" " />

        <treeselect
          :multiple="true"
          :options="lista_carteiras"
          placeholder="Selecione a(s) carteira(s)"
          v-model="filtros.carteira_filter"
        />
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Regime triburario" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.regime_tributario"
        >
          <!-- <option selected disabled>Selecione as carteiras...</option> -->

          <option :value="null">Todos</option>
          <option
            v-for="item in lista_regime_tributario"
            :key="item.id"
            :value="item.label"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="XML" class=" " />
        <b-select
          placeholder="Selecione as opções"
          name="form-class"
          v-model="filtros.xml"
        >
          <option :value="null">Todos</option>
          <option v-for="item in lista_xml" :key="item.id" :value="item.id">
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="DEISS" class=" " />
        <b-select
          placeholder="Selecione as opções"
          name="form-class"
          v-model="filtros.deiss"
        >
          <option :value="null">Todos</option>

          <option v-for="item in lista_deiss" :key="item.id" :value="item.id">
            {{ item.label }}
          </option>
        </b-select>
      </label>
    </div>
    <div class="w-full flex justify-start gap-4 items-center mb-2">
      <label class="w-1/4">
        <Lynx-Label label="DP" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.status_dp"
        >
          <option
            v-for="item in [
              { id: null, label: 'Todos' },
              { id: 1, label: 'Concluido' },
              { id: 0, label: 'Desmarcado' },
              { id: 2, label: 'Não Concluido' },
            ]"
            :key="item.id"
            :value="item.id"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="FISCAL" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.status_fiscal"
        >
          <option
            v-for="item in [
              { id: null, label: 'Todos' },
              { id: 1, label: 'Concluido' },
              { id: 0, label: 'Desmarcado' },
              { id: 2, label: 'Não Concluido' },
            ]"
            :key="item.id"
            :value="item.id"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="WPP" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.status_wpp"
        >
          <option
            v-for="item in [
              { id: null, label: 'Todos' },
              { id: 1, label: 'Concluido' },
              { id: 0, label: 'Desmarcado' },
              { id: 2, label: 'Não Concluido' },
            ]"
            :key="item.id"
            :value="item.id"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="ID Empresas" class=" " />

        <Lynx-Input v-model="empresas_id" />
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Cidades" class=" " />

        <v-autocomplete
          v-model="filtros.cidades"
          :items="lista_cidades"
          :search-input.sync="searchQuery"
          label="Selecione a(s) cidades(s)"
          multiple
          dense
          item-text="nome"
          item-value="nome"
          @change="clearSearchQuery"
        >
        </v-autocomplete>
      </label>

      <label class="flex flex-col w-1/6">
        <Lynx-Label label="Por paginas" class=" " />

        <b-select v-model="filtros.perPage">
          <option
            :value="perPageOption"
            v-for="perPageOption in perPageOptions"
            :key="perPageOption"
          >
            {{ perPageOption }}
          </option>
        </b-select>
      </label>

      <!-- <label class="w-1/6">
      <Lynx-Label label="Faturamento" class=" " />
      <Lynx-Input v-model="faturamento"/>
    </label> -->
    </div>
    <div class="table-container">
      <b-table
        :loading="loading"
        backend-pagination
        @page-change="onPageChange"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        :columns="columns"
        :data="loading ? [] : lista_planilha"
        paginated
        striped
        style="font-size: 12px"
        :style="tamanhoTela"
        :height="filtros.perPage == 10 ? '680' : '100%'"
      >
        <template slot-scope="props" v-if="props.row['id'] != null">
          <b-table-column
            :style="getColStyle(column.field)"
            v-for="column in columns"
            :key="column.field"
            :field="column.field"
            v-show="column.field !== 'acoes'"
            style="height: 20px"
          >
            <!-- You can add custom content here if needed -->
            <div
              v-if="
                column.field === 'empresa_id' ||
                column.field === 'cnpj' ||
                column.field === 'razao_social' ||
                column.field === 'carteira' ||
                column.field === 'cidade' ||
                column.field === 'regime_tributario'
              "
            >
              {{ props.row[column.field] }}
            </div>

            <Lynx-Input
              v-if="column.field === 'fator_ir'"
              :disabled="
                ['Lucro Presumido', 'presumido com equiparação'].includes(
                  props.row['regime_tributario']
                )
              "
              v-model="props.row[column.field]"
            />
            <div v-if="column.field === 'sndas'">
              <span :class="getClass(props.row[column.field])">
                {{ props.row[column.field] }}
              </span>
            </div>

            <Lynx-Input
              v-if="column.field === 'porcetagem'"
              v-model="props.row[column.field]"
            />

            <div v-if="column.field === 'previsao_nf'">
              <b-tag
                :type="
                  props.row[column.field] == props.row['faturamento']
                    ? 'is-success'
                    : 'is-danger'
                "
              >
                R$ {{ props.row[column.field] | money }}
              </b-tag>
            </div>

            <div v-if="column.field == 'emite_nf'">
              <b-tag
                :type="
                  props.row[column.field] == 1
                    ? 'is-success'
                    : props.row[column.field] == 0
                    ? 'is-danger'
                    : 'is-warning'
                "
              >
                {{
                  props.row[column.field] == 1
                    ? "Emite"
                    : props.row[column.field] == 0
                    ? "Não emite"
                    : "Carregue a planilha"
                }}
              </b-tag>
            </div>
            <div v-if="column.field === 'inicio_atividades'">
              {{ props.row[column.field] | formatEnToBr }}
            </div>

            <div v-if="column.field === 'deiss_vencimento'">
              <span v-if="props.row.deiss_msg">{{ props.row.deiss_msg }}</span>
              <span v-else>{{ props.row[column.field] | formatEnToBr }}</span>
            </div>
            <div
              class="flex"
              v-if="
                column.field === 'irrf' ||
                column.field === 'inss' ||
                column.field === 'fgts'
              "
            >
              <InputMoney
                :error="
                  JSON.parse(props.row.valguias)
                    ? JSON.parse(props.row.docguias)[column.field] == 0
                      ? false
                      : JSON.parse(props.row.valguias)[column.field]
                      ? JSON.parse(props.row.valguias)[column.field] !=
                        props.row[column.field]
                      : props.row[column.field] == 0
                    : false
                "
                required
                @input="(money) => (props.row[column.field] = money)"
                v-model="props.row[column.field]"
              ></InputMoney>
              <Lynx-Button
                icon="Eye"
                icon-size="4"
                size="x-small"
                v-show="JSON.parse(props.row.docguias)[column.field] > 0"
                @click.native="
                  handleClick(JSON.parse(props.row.docguias)[column.field])
                "
              />
            </div>
            <div v-if="column.field === 'das'">
              <div
                class="flex"
                v-if="
                  !['Lucro Presumido', 'presumido com equiparação'].includes(
                    props.row['regime_tributario']
                  )
                "
              >
                <InputMoney
                  :error="
                    JSON.parse(props.row.valguias)
                      ? JSON.parse(props.row.docguias)[column.field] == 0
                        ? false
                        : JSON.parse(props.row.valguias)[column.field]
                        ? JSON.parse(props.row.valguias)[column.field] !=
                          props.row[column.field]
                        : props.row[column.field] == 0
                      : false
                  "
                  required
                  @input="(money) => (props.row[column.field] = money)"
                  v-model="props.row[column.field]"
                ></InputMoney>
                <Lynx-Button
                  icon="Eye"
                  icon-size="4"
                  size="x-small"
                  v-show="JSON.parse(props.row.docguias)[column.field] > 0"
                  @click.native="
                    handleClick(JSON.parse(props.row.docguias)[column.field])
                  "
                />
              </div>
              <div v-else>
                <Lynx-Input disabled v-model="props.row[column.field]" />
              </div>
            </div>
            <div
              v-if="
                column.field === 'pis' ||
                column.field === 'iss' ||
                column.field === 'csll' ||
                column.field === 'cofins' ||
                column.field === 'irpj'
              "
              class="flex"
            >
              <div
                v-show="props.row['regime_tributario'] == 'Simples Nacional'"
              >
                R$0,00
              </div>
              <InputMoney
                v-show="props.row['regime_tributario'] != 'Simples Nacional'"
                :error="
                  JSON.parse(props.row.valguias)
                    ? JSON.parse(props.row.docguias)[column.field] == 0
                      ? false
                      : JSON.parse(props.row.valguias)[column.field]
                      ? JSON.parse(props.row.valguias)[column.field] !=
                        props.row[column.field]
                      : props.row[column.field] == 0
                    : false
                "
                required
                @input="(money) => (props.row[column.field] = money)"
                v-model="props.row[column.field]"
              ></InputMoney>

              <Lynx-Button
                icon="Eye"
                icon-size="4"
                size="x-small"
                v-show="JSON.parse(props.row.docguias)[column.field] > 0"
                @click.native="
                  handleClick(JSON.parse(props.row.docguias)[column.field])
                "
              />
            </div>

            <InputMoney
              v-if="column.field === 'faturamento'"
              required
              :error="props.row[column.field] != props.row['previsao_nf']"
              @input="(money) => (props.row[column.field] = money)"
              v-model="props.row[column.field]"
            ></InputMoney>
            <InputMoney
              v-if="
                column.field === 'prolabore' ||
                column.field === 'distribuicao_lucro' ||
                column.field === 'salario_funcionario' ||
                column.field === 'total_guias'
              "
              required
              @input="(money) => (props.row[column.field] = money)"
              v-model="props.row[column.field]"
            ></InputMoney>

            <b-select
              style="font-size: 13px"
              v-if="column.field === 'deiss'"
              placeholder="Selecione as opções"
              name="form-class"
              v-model="props.row['deiss']"
            >
              <option
                v-for="item in lista_deiss"
                :key="item.id"
                :value="item.id"
              >
                {{ item.label }}
              </option>
            </b-select>
            <b-select
              style="font-size: 13px"
              v-if="column.field === 'xml'"
              placeholder="Selecione as opções"
              name="form-class"
              v-model="props.row['xml']"
            >
              <option v-for="item in lista_xml" :key="item.id" :value="item.id">
                {{ item.label }}
              </option>
            </b-select>
            <b-select
              style="font-size: 13px"
              v-if="column.field === 'tp'"
              placeholder="Selecione as opções"
              name="form-class"
              v-model="props.row['tp']"
            >
              <option v-for="item in lista_tp" :key="item.id" :value="item.id">
                {{ item.label }}
              </option>
            </b-select>
            <b-switch
              v-if="
                ['dp', 'fiscal', 'wpp', 'envio_guias'].includes(column.field)
              "
              v-model="props.row[column.field]"
              :true-value="1"
              :false-value="0"
            />
          </b-table-column>

          <!-- <b-table-column field="id">
          <Lynx-Input type="number" v-model="props.row.id" />

        </b-table-column> -->

          <!-- <b-table-column field="acoes" style="width:300px;" >
            <Lynx-Button
        
              text="salvar"
              icon-size="7"
              size="small"
              color="primary-600"
              @click.native="atualizarPlaniha(props, props.row)"
            />
            <v-btn
              v-if="hasRole('super-admin') && props.row.user_up"
              small
              dark
              @click.native="open(props.row.user_up)"
            >
              logs
            </v-btn>
            <v-snackbar
              v-if="logs"
              color="primary"
              shaped
              v-model="logs"
              :vertical="false"
            >
              <span style="font-size: 15px"
                >ATUALIZOU: {{ user_up.toUpperCase() }}
              </span>
              <br />

              <template v-slot:action="{ attrs }">
                <v-btn color="error" icon v-bind="attrs" @click.native="hide()">
                  <v-icon large> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-snackbar>
          </b-table-column> -->
          <b-table-column
            style="
              width: 200px;
              position: absolute;
              right: 35px;
              z-index: 100;
              background-color: #031127;
              color: white;
            "
          >
            <Lynx-Button
              text="salvar"
              icon-size="7"
              size="small"
              color="primary-600"
              @click.native="atualizarPlaniha(props, props.row)"
            />
            <v-btn
              v-if="hasRole('super-admin') && props.row.user_up"
              small
              dark
              @click.native="open(props.row.user_up)"
            >
              logs
            </v-btn>
            <v-snackbar
              v-if="logs"
              color="primary"
              shaped
              v-model="logs"
              :vertical="false"
            >
              <span style="font-size: 15px"
                >ATUALIZOU: {{ user_up.toUpperCase() }}
              </span>
              <br />
              <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

              <template v-slot:action="{ attrs }">
                <v-btn color="error" icon v-bind="attrs" @click.native="hide()">
                  <v-icon large> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-snackbar>
          </b-table-column>
        </template>
        <template #empty>
          <div class="w-full flex justify-center">
            <Not-Found-Data text="Nenhum Tabela carregada!" />
          </div>
        </template>
      </b-table>
      <div class="float-left" style="margin-top: -60px">
        <b-pagination
          :total="pagination.total"
          :current.sync="current_page"
          :per-page="pagination.per_page"
        />
      </div>
    </div>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";
import InputMoney from "@/components/helpers/InputMoney";
import { monthNames } from "@/utils/utils";
import { carteirasRequest } from "../../services/requests/carteiras";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import { usersRequest } from "@/services/requests/users";
import Treeselect from "@riophae/vue-treeselect";

import { showCidadesRequest } from "../../services/requests/estados";

export default {
  components: { NotFoundData, InputMoney, Treeselect },
  data() {
    return {
      monthNames,
      form: [],
      selectedFiles: [],
      loading: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      logs: false,
      searchQuery: null,
      columns: [
        // {
        //   field: "id",
        //   label: "id",
        //   sortable: true,
        // },
        {
          field: "empresa_id",
          label: "empresa_id",
          sortable: true,
        },

        {
          field: "cnpj",
          label: "cnpj",
        },
        {
          field: "razao_social",
          label: "razão social",
          sortable: true,
        },

        {
          field: "cidade",
          label: "cidade",
          sortable: true,
        },
        {
          field: "carteira",
          label: "carteira",
          sortable: true,
        },
        {
          field: "regime_tributario",
          label: "regime tributario",
        },
        {
          field: "inicio_atividades",
          label: "data Inicio",
        },
        {
          field: "xml",
          label: "XML",
          sortable: true,
        },
        {
          field: "deiss_vencimento",
          label: "DEISS VENCIMENTO",
          sortable: true,
        },
        {
          field: "deiss",
          label: "DEISS",
          sortable: true,
        },
        {
          field: "emite_nf",
          label: "EMITE NF",
          sortable: true,
        },
        {
          field: "previsao_nf",
          label: "NF",
          sortable: true,
        },
        {
          field: "faturamento",
          label: "Faturamento",
          sortable: true,
        },
        {
          field: "das",
          label: "DAS",
        },
        {
          field: "sndas",
          label: "%SN/DAS",
        },
        {
          field: "fator_ir",
          label: "FATOR IR",
        },
        {
          field: "iss",
          label: "ISS",
        },
        {
          field: "pis",
          label: "PIS",
        },
        {
          field: "cofins",
          label: "COFINS",
        },
        {
          field: "csll",
          label: "CSLL",
        },
        {
          field: "irpj",
          label: "IRPJ",
        },
        {
          field: "prolabore",
          label: "PROLABORE",
          sortable: true,
        },
        {
          field: "tp",
          label: "T/P",
        },
        {
          field: "inss",
          label: "INSS",
        },

        {
          field: "irrf",
          label: "IRRF",
        },
        {
          field: "fgts",
          label: "FGTS",
        },
        {
          field: "total_guias",
          label: "TOTAL GUIAS",
          sortable: true,
        },
        {
          field: "porcetagem",
          label: "%",
          sortable: true,
        },
        {
          field: "envio_guias",
          label: "ENVIO DE GUIAS",
        },
        {
          field: "dp",
          label: "DP",
          sortable: true,
        },
        {
          field: "fiscal",
          label: "FISCAL",
          sortable: true,
        },
        {
          field: "wpp",
          label: "WPP",
          sortable: true,
        },
        {
          field: "distribuicao_lucro",
          label: "distribuição de lucro",
          sortable: true,
        },
        {
          field: "salario_funcionario",
          label: "Salario de funcionario",
          sortable: true,
        },

        {
          field: "acoes",
          label: "acoes",
        },
      ],

      lista_tp: [
        { id: 1, label: "TETO PARCIAL" },
        { id: 2, label: "TETO MAXIMO" },
        { id: 3, label: "NORMAL" },
        { id: 4, label: "NÃO RECOLHE" },
      ],

      lista_deiss: [
        // { id: 0, label: "Seleciona as opcoes" },

        { id: 1, label: "ABERTO" },
        { id: 2, label: "DESATIVADA" },
        { id: 3, label: "FECHADO" },
        { id: 4, label: "NÃO SE APLICA" },
        { id: 5, label: "SEM ACESSO" },
      ],
      lista_xml: [
        // { id: 0, label: "Seleciona as opcoes" },

        { id: 1, label: "DESATIVADA" },
        { id: 2, label: "MANUAL" },
        { id: 3, label: "MEI" },
        { id: 4, label: "NÃO EMITIR" },
        { id: 5, label: "OK" },
        { id: 6, label: "PORTAL BLOQUEADO" },
        { id: 7, label: "SAIU SISTEMA" },
        { id: 8, label: "SEM ACESSO DE NOTAS" },
        { id: 9, label: "SEM CERTIFICADO" },
        { id: 10, label: "SEM MOVIMENTO" },
      ],
      lista_usuarios: null,
      user_up: false,
      faturamento: 0,
      lista_regime_tributario: [
        { id: "Simples Nacional", label: "Simples Nacional" },
        { id: "Lucro Presumido", label: "Lucro Presumido" },
        { id: "Isento", label: "Isento" },
        {
          id: "Aguardando enquadramento no simples",
          label: "Aguardando enquadramento no simples",
        },
        { id: "presumido com equiparação", label: "presumido com equiparação" },
        {
          id: "Microempreendedor Individual (MEI)",
          label: "Microempreendedor Individual (MEI)",
        },
      ],

      planilha_fechamento: null,
      empresas_id: "",
      lista_cidades: null,
      filtros: {
        page: 1,
        empresas_id: null,
        faturamento_filter: null,
        prolabore_filter: null,
        filtro_data: null,
        carteira_filter: [],
        status_dp: null,
        status_fiscal: null,
        status_wpp: null,
        regime_tributario: null,
        deiss: null,
        xml: null,
        cidades: [],
        perPage: 10,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  watch: {
    "filtros.perPage"() {
      this.listar_planilha();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_planilha();
    },
    faturamento() {
      if (this.faturamento < 1) {
        this.faturamento = 0;
      }
    },
    searchQuery: _.debounce(function () {
      if (this.searchQuery.length > 3) {
        this.searchCidades();
      }
    }, 400), // Adiciona um atraso de 300ms para evitar múltiplas chamadas durante a digitação
  },

  computed: {
    ...mapGetters(["getToken"]),
    tamanhoTela() {
      const tamanhoFixo = 7850;
      const larguraTela =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const tamanhoRelativo = (tamanhoFixo / larguraTela) * 100;
      const tamanhoFinal = tamanhoRelativo;
      return `width:${tamanhoFinal}vw;`;
    },
    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;

      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      // data.push({ id: 'todas', label: 'todas',disabled:true });

      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      for (let i = 0; i < carteira.length; i++) {
        if (
          carteira[i].setor == "onboarding" &&
          carteira[i].nome != "Onboarding"
        ) {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      return data;
    },

    planilha_contabilidade() {
      return this.$store.state.planilhaContabilidade.lista_planilha;
    },
    lista_planilha() {
      return this.planilha_contabilidade.data;
    },
    pagination() {
      return this.planilha_contabilidade.pagination;
    },
    competencia() {
      return {
        gerado: this.planilha_contabilidade.gerado,
        competencia: this.planilha_contabilidade.competencia,
      };
    },

    mensagem_alert() {
      return this.$store.state.planilhaContabilidade.mensagem_alert;
    },
  },
  created() {
    this.getUsers();
    this.fetchCarteiras();
  },
  mounted() {
    this.listar_planilha();
  },
  filters: {
    formatEnToBr,
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    hasRole,
    async fetchCarteiras() {
      await this.$store.dispatch("carteira/listar_carteiras");
    },
    pegarUsuario(val) {
      let a = this.lista_usuarios.filter((item) => item.id == val);

      this.user_up = a[0].label;
    },
    clearSearchQuery() {
      this.searchQuery = "";
    },
    searchCidades() {
      this.loading = true;

      showCidadesRequest(this.searchQuery)
        .then((res) => {
          this.lista_cidades = res.data.map((item) => {
            return {
              id: item.nome,
              nome: item.nome + "-" + item.estado.uf,
            };
          });
        })
        .finally(() => (this.loading = false));
    },

    async getUsers() {
      await usersRequest().then(({ data: { data } }) => {
        let arrayNew = [];
        for (let i = 0; i < data.length; i++) {
          arrayNew.push({ id: data[i].id, label: data[i].nome_completo });
        }
        this.lista_usuarios = arrayNew;
      });
      // console.log(this.lista_usuarios);
    },
    open(val) {
      this.pegarUsuario(val);
      this.logs = true;
    },
    hide() {
      this.logs = false;
    },
    enterCompetencia() {
      this.$router.push({ name: "planilha.fechamento" });
    },
    async listar_planilha() {
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }

      const { filtros } = this;

      let rota = "planilha-contabilidade/" + this.$route.params.tabelas_id;

      await this.$store.dispatch("planilhaContabilidade/listar_planilha", {
        rota: rota,
        filtros: filtros,
      });
      this.loading = false;
    },

    async carregarPlanilha() {
      let ids = [];
      if (this.lista_planilha) {
        ids = this.lista_planilha.map((item) => item.id);
      }
      this.loading = true;
      await this.$store.dispatch("planilhaContabilidade/carregar_planilha", {
        tabelas_id: this.$route.params.tabelas_id,
        ids: ids,
      });
      await this.listar_planilha();

      this.$snack.success(this.mensagem_alert.message);

      this.loading = false;
    },
    getCamposAlterados(novoValor, valorAntigo) {
      let camposAlterados = {};

      // console.log(valorAntigo)
      const valores = [
        "dp",
        "id",
        "tp",
        "das",
        "iss",
        "pis",
        "xml",
        "csll",
        "inss",
        "fgts",
        "irpj",
        "irrf",
        "deiss",
        "sndas",
        "cidade",
        "cofins",
        "fiscal",
        "user_up",
        "fator_ir",
        "prolabore",
        "porcetagem",
        "envio_guias",
        "faturamento",
        "porcentagem",
        "previsao_nf",
        "emite_nf",
        "total_guias",
        "inicio_atividades",
        "salario_funcionario",
        "wpp",
      ];
      camposAlterados["id"] = novoValor["id"];

      for (let i = 0; i < valores.length; i++) {
        console.log(
          valores[i] +
            ": " +
            novoValor[valores[i]] +
            "!==" +
            valorAntigo[valores[i]]
        );
        if (novoValor[valores[i]] !== valorAntigo[valores[i]]) {
          camposAlterados[valores[i]] = novoValor[valores[i]];
        }
      }

      return camposAlterados;
    },
    async atualizarPlaniha(props, value) {
      // let guiasval = this.planilha_fechamento.filter(
      //   (item) => item.id == props.row.id
      // )[0];
      // if (value.das == guiasval.das) {
      // }

      // this.loading = true;

      // value.total_guias =
      //   parseFloat(value.das) +
      //   parseFloat(value.irrf) +
      //   parseFloat(value.inss) +
      //   parseFloat(value.cofins) +
      //   parseFloat(value.irpj) +
      //   parseFloat(value.iss) +
      //   parseFloat(value.pis) +
      //   parseFloat(value.csll);

      // value.porcentagem =
      //   value.faturamento === 0 || value.total_guias === 0
      //     ? "0%"
      //     : ((value.faturamento / value.total_guias) * 100)
      //         .toFixed(2)
      //         .replace(".", ",") + "%";

      // value.sndas =
      //   value.faturamento === 0 || value.das === 0
      //     ? "0%"
      //     : ((value.das / value.faturamento) * 100)
      //         .toFixed(2)
      //         .replace(".", ",") + "%";

      // const camposAlterados = this.getCamposAlterados(
      //   value,
      //   this.lista_planilha.data.filter((item) => item.id == props.row.id)[0]
      // );

      await this.$store
        .dispatch("planilhaContabilidade/update_planilha", value)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getClass(valor) {
      return {
        "bg-error-base rounded-full p-2 text-neutral-200":
          parseFloat(valor) >= 15,
      };
    },
    onPageChange(page) {
      this.current_page = page;
    },

    async exportPlanilha(nome) {
      this.loading = true;
      let data = { id: this.$route.params.tabelas_id };
      await this.$store.dispatch("empresas/" + nome, data);
      this.loading = false;
    },

    handleClick(value) {
      // Ação ao clicar (clique duplo)
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${value}/open?token=${this.getToken}`
      );
    },

    getColStyle(field) {
      switch (field) {
        case "empresa_id":
          return "width: 10px;  position: sticky;left: 0; background-color: #fff;z-index: 1;background-color:#031127; color:white";

          break;
        case "cnpj":
          return "width: 100px;  position: sticky;left: 80px; background-color: #fff;z-index: 2;background-color:#031127; color:white";

          break;

        case "faturamento":
          return "width: 150px;";

          break;

        case "razao_social":
          return "width: 500px;";

          break;
        case "iss":
          return "width: 250px;";

          break;
        case "pis":
          return "width: 250px;";

          break;
        case "das":
          return "width: 250px;";

          break;
        case "irrf":
          return "width: 250px;";

          break;
        case "csll":
          return "width: 250px;";

          break;
        case "irpj":
          return "width: 250px;";

          break;
        case "cofins":
          return "width: 250px;";
          break;
        case "inss":
          return "width: 250px;";
          break;
        case "fgts":
          return "width: 250px;";
          break;
        case "porcetagem":
          return "width: 120px;";
          break;
        case "regime_tributario":
          return "width: 250px;";
          break;
        case "xml":
          return "width: 250px;";
          break;
        case "deiss":
          return "width: 250px;";
          break;
        case "deiss_vencimento":
          return "width: 250px;";
          break;
        case "tp":
          return "width: 250px;";
          break;
        case "emite_nf":
          return "width: 250px;";
          break;
          case "previsao_nf":
            return "width: 250px;";
            break;
        default:
          return "width: 200px;";
          break;
      }
    },
  },
};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
  width: 100%;
}
</style>

  
